import { __ } from "bits/intl"
import { trackEvent } from "bits/analytics"
import { UploadJob, FILE_TOO_LARGE_ERROR } from "bits/uploader";
const DEFAULT_MAX_SIZE = 26214400 //25MB

export default {
  props: {
    file: {
      required: true
    },
    name: String,
    maxFileSize: {
      type: Number,
      default: DEFAULT_MAX_SIZE
    }
  },
  data() {
    return {
      error: false,
      canRetryUpload: true,
      progress: 0
    };
  },
  computed: {
    filename() {
      return this.name || this.file.name;
    },
    fileUrl() {
      if (this.file) {
        return URL.createObjectURL(this.file);
      }
    }
  },
  methods: {
    cancelUpload() {
      if (this._uploadJob) this._uploadJob.cancel();
      this.$emit("cancel", this.file);
    },
    _onDone(response) {
      trackEvent("Uploader", "Done");
      this.onDone();
      this.$emit("done", this.file, response.url);
    },
    onDone() {
      // implement your own
    },
    _onError(response = {}) {
      if(response.error == FILE_TOO_LARGE_ERROR) {
        this.$emit("reject", this.file, { size: true })
        trackEvent("Uploader", "Reject");
      }
      else {
        let errorText = __("Sorry, there was an error uploading your file.");
        this.error = errorText;
        this.canRetryUpload = true;
        trackEvent("Uploader", "Error");
        this.$emit("error", this.file, errorText);
      }
    },
    // onError() {
    //   // implement your own
    // },
    _onProgress(progress) {
      this.progress = progress;
    },
    startUpload() {
      this.error = false;
      const onDone = this._onDone.bind(this);
      const onError = this._onError.bind(this);
      const onProgress = this._onProgress.bind(this);
      this._uploadJob = new UploadJob(this.file, { maxFileSize: this.maxFileSize });
      this._uploadJob.on("done", onDone);
      this._uploadJob.on("error", onError);
      this._uploadJob.on("progress", onProgress);
      this._uploadJob.perform();
    }
  },
  mounted() {
    this.startUpload();
  },
  beforeDestroy() {
    if (this._uploadJob) this._uploadJob.cancel();
  }
};
